import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationEnd } from '@angular/router';
import { StoresService } from 'src/app/core/services/stores.service';
import { OrdersService } from 'src/app/core/services/orders.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit, OnDestroy {
  @ViewChild('modalContentStore') modalContentStore: TemplateRef<any>;
  private navigationSubscription: Subscription;
  public iconOnlyToggled = false;
  public sidebarToggled = false;
  storeName = "";

  stores = [];
  selectedStore$ = this.storeService.selectedStore$;
  selectedStore = this.storeService.getSelectedStore;
  url:String;
  storesOrigin = [];
  dolar_value = 0;
  isSmallScreen: boolean;
  eur_value = 0;

  private uniqueModalInstances: { [itemId: number]: NgbModalRef } = {};

  constructor(config: NgbDropdownConfig, private router: Router,private storeService: StoresService,private storesService: StoresService,
    private modalService: NgbModal,private media: MediaMatcher, private ordersService: OrdersService) {
    config.placement = 'bottom-right';
    this.isSmallScreen = media.matchMedia('(max-width: 991px)').matches;

    media.matchMedia('(max-width: 991px)')
      .addEventListener('change', (e) => {
        this.isSmallScreen = e.matches;
      });
  }

  ngOnInit() {
    this.selectedStore = "";
    if(localStorage.getItem("STORE") != null && localStorage.getItem("STORE") != undefined && localStorage.getItem("STORE") != ""){
      this.storeName = localStorage.getItem("STORE");
    }
    this.getStores();

    this.dolar_value = localStorage.getItem('Bcv_USD')? +localStorage.getItem('Bcv_USD') : 0;
    this.eur_value = localStorage.getItem('Bcv_EUR')? +localStorage.getItem('Bcv_EUR') : 0;

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
          if (e instanceof NavigationEnd)  
            {
              if(this.url != e.url && (this.selectedStore == null || this.selectedStore == undefined || this.selectedStore == "") && !localStorage.getItem("STORE")){
                this.openMediumModal(1,this.modalContentStore);
              }
              this.url = e.url;
            }
         });
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  // toggle sidebar in small devices
  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  // toggle sidebar
  toggleSidebar() {
    let body = document.querySelector('body');
    if((!body.classList.contains('sidebar-toggle-display')) && (!body.classList.contains('sidebar-absolute'))) {
      this.iconOnlyToggled = !this.iconOnlyToggled;
      if(this.iconOnlyToggled) {
        body.classList.add('sidebar-icon-only');
      } else {
        body.classList.remove('sidebar-icon-only');
      }
    } else {
      this.sidebarToggled = !this.sidebarToggled;
      if(this.sidebarToggled) {
        body.classList.add('sidebar-hidden');
      } else {
        body.classList.remove('sidebar-hidden');
      }
    }
  }

  logout(): void {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('EMAIL');
    localStorage.removeItem('ROLE');
    localStorage.removeItem('STOREID');
    localStorage.removeItem('STORE');

    localStorage.clear();
    this.router.navigate(['/user-pages/login']);
  }

  getStores() {
    this.storeService.getStores(1)
    .subscribe(async retrievedStores => {
      this.stores = [];
      this.storesOrigin = retrievedStores;
      for(let store of retrievedStores) {
        //if(store.status){
          this.stores.push({id: store.id, name: store.socialName, specialTaxpayer:store.specialTaxpayer});
        //}
      }
      if(localStorage.getItem("STOREID") != null && localStorage.getItem("STOREID") != undefined && localStorage.getItem("STOREID") != ""){
        let selectedStore = this.stores.find(store => store.id === +localStorage.getItem("STOREID"));
        this.selectedStore = selectedStore.id;
        this.selectStore(selectedStore.id);
      }
    })
  }

  selectStore(store) {
    let storeId = store;
    localStorage.setItem("STORESELECT", JSON.stringify(this.storesOrigin.find(store => store.id === +storeId)));
    this.storeService.setSelectedStore(store);
    this.selectedStore.unsubscribe;
    if(this.dolar_value == 0){
      this.fetchPrices(storeId);
    }
    this.storesService.getShedule(storeId,new Date().getDay()).subscribe(store =>{
      let shedule = {"date":new Date(), "open": store[0].open,"close": store[0].close};
      localStorage.setItem('shedule',JSON.stringify(shedule));
    });
    this.storeService.setSpecialTaxpayerStore(this.stores.find(store => store.id === +storeId).specialTaxpayer);
  }

  async openMediumModal(itemId, mediumModalContent) {
    if (this.uniqueModalInstances[itemId]) {
      return;
    }
    const modalRef: NgbModalRef = this.modalService.open( mediumModalContent, {
      ariaLabelledBy: `modal-title-${itemId}`, // ID único para accesibilidad
      backdrop: 'static', // Opcional: para que no se cierre al hacer clic fuera
      keyboard: false // Opcional: para que no se cierre con ESC
    });
    this.uniqueModalInstances[itemId] = modalRef;

    modalRef.result.then((result) => {
    }, (reason) => {
    }).finally(() => {
      delete this.uniqueModalInstances[itemId];
    });
  }

  fetchPrices(storeId){
    this.ordersService.calculatePrices(1,storeId,[]).subscribe((prices) => {
      localStorage.setItem("PaypalPercentaje",JSON.stringify(prices.paypal));
      prices.rates.forEach(rate =>{
        switch(rate.name){
        case ("IVA"):{
          localStorage.setItem("Iva",rate.percentage);
          break;
        }
        case ("IGTF"):{
          localStorage.setItem("Igtf",rate.percentage);
          break;
        }
        case ("SERVICES"):{
          localStorage.setItem("Services",rate.percentage);
          break;
        }
        case ("BCV_USD"):{
          localStorage.setItem("Bcv_USD",rate.percentage);
          this.dolar_value = rate.percentage
          break;
        }
        case ("BCV_EUR"):{
          localStorage.setItem("Bcv_EUR",rate.percentage);
          this.eur_value = rate.percentage;
          break;
        }
      }
      });

    });
  }

  // toggle right sidebar
  // toggleRightSidebar() {
  //   document.querySelector('#right-sidebar').classList.toggle('open');
  // }

}
